export const pageSizeOptions = [25, 50, 100] as const;
